// extracted by mini-css-extract-plugin
export default {"lightFooterContainer":"footer_lightFooterContainer__OCCNI","footerParagraph":"footer_footerParagraph__faXuM","darkFooterContainer":"footer_darkFooterContainer__KMxS5"};